import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationEspBrazeData } from './Data';
import { Component } from 'vue';

export type IntegrationEspBrazeState = BaseIntegrationState;

export class IntegrationEspBrazeModel extends BaseIntegration<IntegrationEspBrazeData, IntegrationEspBrazeState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/esp/braze/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
